/**
 * TanStack Query hooks for `igaming-license-specific-dashboards-mga-cura-ao-lo`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingLicenseSpecificDashboardsMgaCuraAoLoQueryKeys,
	type CreateIgamingLicenseSpecificDashboardsMgaCuraAoLoBody,
	type ListIgamingLicenseSpecificDashboardsMgaCuraAoLoResponse,
	type IgamingLicenseSpecificDashboardsMgaCuraAoLoRow,
} from "./api";

export function useIgamingLicenseSpecificDashboardsMgaCuraAoLoList(): UseQueryResult<ListIgamingLicenseSpecificDashboardsMgaCuraAoLoResponse, Error> {
	return useQuery({
		queryKey: igamingLicenseSpecificDashboardsMgaCuraAoLoQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingLicenseSpecificDashboardsMgaCuraAoLoCreate(): UseMutationResult<IgamingLicenseSpecificDashboardsMgaCuraAoLoRow, Error, CreateIgamingLicenseSpecificDashboardsMgaCuraAoLoBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingLicenseSpecificDashboardsMgaCuraAoLoQueryKeys.all });
		},
	});
}

export function useIgamingLicenseSpecificDashboardsMgaCuraAoLoDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingLicenseSpecificDashboardsMgaCuraAoLoQueryKeys.all });
		},
	});
}
